import { Carousel, Card } from "react-bootstrap";
import img1 from "../../../../assets/images/jardin4.jpg";
import img2 from "../../../../assets/images/inicial3.jpg";
import img3 from "../../../../assets/images/edifi1.jpg";

const imagenesExalumnos = [
  { src: img1, alt: "Sede 1" },
  { src: img2, alt: "Sede 2" },
  { src: img3, alt: "Sede 3" },
];

function HorariosSedes() {
  return (
    <div className="container my-5">
      <Card className="bg-dark text-white shadow-lg border-0 rounded-4 p-4" data-aos="fade-left">
        <Card.Body>
          <h2 className="text-center fw-bold mb-4" style={{ color: "yellow" }}>
            Sedes y Horarios
          </h2>
          <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-4">
            
            {/* TEXTO a la izquierda */}
            <div
              className="mt-4 mt-md-0"
              style={{
                maxWidth: "600px",
                textAlign: "justify",
                color: "#f8f9fa",
                fontSize: "16px",
                lineHeight: "1.6",
              }}
            >
              <hr className="border-top border-light opacity-50" />
              <h5 className="fw-bold">Nivel Inicial</h5>
              <p>
                <strong>Ubicación:</strong> Estrada 168, Santa Rosa <br />
                <strong>Horarios:</strong> 13:30 a 17:00
              </p>
              <hr className="border-top border-light opacity-50" />
              <h5 className="fw-bold">Nivel Primario</h5>
              <p>
                <strong>Ubicación:</strong> Neuquén 745 <br />
                <strong>Horario:</strong> 13:30 a 17:30 <br />
                <strong>Horario intensivo:</strong> 8:45 a 11:45 y 13:30 a 17:30
              </p>
              <hr className="border-top border-light opacity-50" />
              <h5 className="fw-bold">Nivel Secundario</h5>
              <p>
                <strong>Inglés Curricular:</strong> 3 hs cátedra. Una clase de 12:10 a 12:50 y otra de 12:10 a 13:30 hs.
              </p>
              <hr className="border-top border-light opacity-50" />
              <h5 className="fw-bold">Inglés Intensivo</h5>
              <p>Lunes a jueves de 13:30 a 15:30 hs.</p>
              <h5 className="fw-bold">Educación Física</h5>
              <p>
                2 veces por semana en contra-turno (por la tarde). <br />
                Los horarios específicos de la jornada de la mañana se informan previo al inicio del ciclo lectivo.
              </p>
            </div>

            {/* Carrusel a la derecha */}
            <div className="w-100" style={{ maxWidth: "500px", height: "500px", overflow: "hidden" }}>
              <Carousel className="shadow-lg rounded-3">
                {imagenesExalumnos.map((imagen, index) => (
                  <Carousel.Item key={index}>
                    <img
                      className="d-block w-100"
                      src={imagen.src}
                      alt={imagen.alt}
                      style={{
                        height: "500px",
                        objectFit: "cover",
                        borderRadius: "10px",
                      }}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
            
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default HorariosSedes;
